import { Container } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { ItemList } from "../itemlist/ItemList";
//import { Header } from "../header/Header";
import { TopPan } from "../topPan/TopPan";
import "../home/home.css";
export const Home = () => {
  const [data, setData] = useState([]);
  const [hoveredVideo, setHoveredVideo] = useState(null);

  useEffect(() => {
    fetch("https://dispatch.whizti.com/api/publication/743")
      .then((response) => response.json())
      .then((json) => {
        // console.log("API response:", json);
        setData(json);
      });
  }, []);

  const categories = data?.response?.categories;
  const weatherUrl = data?.response?.config?.weather_url;

  return (
    <Container fluid>
      {/* <Header /> */}
      <div className="home-container">
        <div className="top-pan-wrapper">
          {categories && (
            <TopPan
              video={hoveredVideo}
              category={categories[0]}
              index={0}
              weatherUrl={weatherUrl}
            />
          )}
        </div>
        <div className="item-list-wrapper">
          {categories?.length ? (
            categories.map((cat, idx) => (
              <Container fluid key={cat.id} className="mt-1 ">
                <div key={cat.id}>
                  <h4>{cat?.label ?? JSON.stringify(cat)}</h4>
                </div>
                <ItemList
                  catid={cat.id}
                  onHover={(video) => setHoveredVideo(video)}
                />
              </Container>
            ))
          ) : (
            <span>No categories found</span>
          )}
        </div>
      </div>
    </Container>
  );
};
